import { render, staticRenderFns } from "./dial-pad.vue?vue&type=template&id=08f23634&scoped=true"
import script from "./dial-pad.vue?vue&type=script&lang=js"
export * from "./dial-pad.vue?vue&type=script&lang=js"
import style0 from "./dial-pad.vue?vue&type=style&index=0&id=08f23634&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f23634",
  null
  
)

export default component.exports